import { jsx, Fragment } from 'react/jsx-runtime';
import { ErrorPanel } from '@backstage/core-components';
import { useApp } from '@backstage/core-plugin-api';
import Button from '@material-ui/core/Button';
import { useCookieAuthRefresh } from '../../hooks/useCookieAuthRefresh/useCookieAuthRefresh.esm.js';

function CookieAuthRefreshProvider(props) {
  const { children, ...options } = props;
  const app = useApp();
  const { Progress } = app.getComponents();
  const result = useCookieAuthRefresh(options);
  if (result.status === "loading") {
    return /* @__PURE__ */ jsx(Progress, {});
  }
  if (result.status === "error") {
    return /* @__PURE__ */ jsx(ErrorPanel, { error: result.error, children: /* @__PURE__ */ jsx(Button, { variant: "outlined", onClick: result.retry, children: "Retry" }) });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
}

export { CookieAuthRefreshProvider };
//# sourceMappingURL=CookieAuthRefreshProvider.esm.js.map
